import { Toaster } from "sonner";
import { RouterHandler } from "./RouterHandler";
import REACTGA from "react-ga4";

REACTGA.initialize("G-8V2VQWGPDL");
function App() {
  return (
    <div>
      <Toaster richColors position="top-center" />
      <RouterHandler />
    </div>
  );
}

export default App;
